import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type UserStore = {
  user: any;
  customer: any;
  customers: any;
  customerId: any;
  isAuthenticated: boolean;
  tokens: {
    accessToken: any;
    idToken: any;
  };
  userData: any;
  setLoginData: (data: any) => void;
  logout: () => void;
  selectedAccount: any;
  giftFormDataLS: any;
};

export const userStore = create<any>(
  persist(
    (set, get) => ({
      user: {},
      customer: {},
      customers: [],
      customerId: '',
      isAuthenticated: false,
      tokens: { accessToken: null, idToken: null },
      userData: {},
      selectedAccount: {},
      giftFormDataLS: {},
      setUser: (user) => set({ user: user }),
      setCustomer: (customer) => set({ customer: customer }),
      setCustomers: (customers) => set({ customers: customers }),
      setCustomerId: (customerId) => set({ customerId: customerId }),
      setSelectedAccount: (selectedAccount) =>
        set({ selectedAccount: selectedAccount }),
      setgiftFormDataLS: (giftFormDataLS) => set({ giftFormDataLS: giftFormDataLS }),
      logout: () => {
        set({
          userData: {},
          tokens: { accessToken: null, idToken: null },
          isAuthenticated: false,
          selectedAccount: {},
          user: {},
          customer: {},
          customerId: '',
          giftFormDataLS: {},
        });
      },
      setLoginData: (data): void => {
        // const { isAuthenticated ,tokens ,userData } = get();
        set({ isAuthenticated: true });
        set({ tokens: data.tokens });
        set({ userData: data.userData });
        set({ user: {} });
        set({ customer: {} });
        set({ customerId: '' });
        set({ selectedAccount: {} });
        set({ giftFormDataLS: {} });
      },
      clearUserStore: () =>
        set({
          user: {},
          customer: {},
          customers: [],
          customerId: '',
          isAuthenticated: false,
          tokens: { accessToken: null, idToken: null },
          userData: {},
          selectedAccount: {},
          giftFormDataLS: {},
        }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
